import React from 'react';
import { IntlProvider } from 'react-intl';
import { useSettings } from './contexts/SettingsContextUtils';
import { NotificationContainer } from './components/common/react-notifications';
import UserContextProvider from './contexts/user/UserContextProvider';
import { getDirection } from './helpers/Utils';
import { MenuProvider } from './contexts/MenuContext';
import availableLanguages from 'lang/availableLanguages';
import { AuthProvider } from './contexts/AuthContext';
import RouterMap from './router';
import * as Sentry from "@sentry/react";
import { transformMessages } from './helpers/utils-typescript';

// the following fixes the problem that we have with react-image-lightbox (global is not defined)
// after the package is removed, this can probably too be removed
window.global ||= window;

const App: React.FC = () => {
  const { locale } = useSettings();

  React.useEffect(() => {
    const direction = getDirection();
    if (direction.isRtl) {
      document.body.classList.add('rtl');
      document.body.classList.remove('ltr');
    } else {
      document.body.classList.add('ltr');
      document.body.classList.remove('rtl');
    }
  }, []);

  const currentLanguageTranslations = availableLanguages[locale] || availableLanguages['en'];
  return (
    <UserContextProvider>
      <IntlProvider
        locale={locale}
        defaultLocale="en"
        messages={transformMessages(currentLanguageTranslations)}
        onError={(err) => {
          console.warn('IntlProvider error:', err);
        }}
      >
        <NotificationContainer />
        <AuthProvider>
          <MenuProvider>
            <RouterMap />
          </MenuProvider>
        </AuthProvider>
      </IntlProvider>
    </UserContextProvider>
  );
}

const AppWithProfiler = Sentry.withProfiler(App);

export default AppWithProfiler;
